import React, {useState, useEffect} from 'react';
import {v4 as uuid} from 'uuid';
import {chunk} from 'lodash-es';
import Layout from './components/Layout';
import styled from 'styled-components';
import {scroller} from 'react-scroll';

import Img from './components/Img';
import OuterLink from './components/OuterLink';
import withHover from './HOC/withHover';
import Card from './components/Card';
import Pagination from './components/Pagination';
import ScrollLink from './components/ScrollLink';
import {GridStyles} from './styles/Grids';
import {breakPoint} from './styles/var';
import {posts} from './data';

// imgs
import kv_banner from './asset/img/01-bgv2.png';
import kv_banner_s from './asset/img/m1-1bg.png';
import kv_1v2 from './asset/img/m1-1.png';
import img_m1_5 from './asset/img/m1-5-2.png';
import img_1_2 from './asset/img/1-5-2.png';
import img_02_1v2 from './asset/img/02-1v2.png';
import img_m2v2 from './asset/img/m2.png';
import img_title1 from './asset/img/title01.png';
import img_mtitle1 from './asset/img/mtitle01.png';
import img_title2 from './asset/img/title02.png';
import img_mtitle2 from './asset/img/mtitle02.png';
import img_title3 from './asset/img/title03.png';
import img_mtitle3 from './asset/img/mtitle03.png';
import img_title4 from './asset/img/title04.png';
import img_mtitle4 from './asset/img/mtitle04.png';
import img_title5 from './asset/img/title05.png';
import img_mtitle5 from './asset/img/mtitle05.png';
import img_3_1 from './asset/img/03-1.png';
import img_m3_2 from './asset/img/m3-2.png';
import img_4_1 from './asset/img/04-1.png';
import img_m4_1 from './asset/img/m4-1.png';
import img_4_2 from './asset/img/04-2.png';
import img_m4_2 from './asset/img/m4-2.png';
import img_5_1 from './asset/img/05-1v2.png';
import img_m5_1 from './asset/img/m5-1v2.png';
import img_5_8 from './asset/img/05-8.png';
import img_m5_8 from './asset/img/m05-8.png';
import img_m5_7 from './asset/img/m05-7.png';

const CusLink1 = withHover(ScrollLink);
const CusLink = withHover(OuterLink);

const KVStyles = styled.div`
  position: relative;
  z-index: var(--level1);

  .fixed {
    position: absolute;
    z-index: 1;
  }

  .btn-wrap {
    display: block;
    width: 18%;
    position: absolute;
    bottom: 20%;
    left: 54.5%;
  }

  @media (min-width: ${breakPoint.min}) {
    .kv_1v2 {
      display: none;
    }
  }
  @media (max-width: ${breakPoint.max}) {
    .kv_banner {
      > img {
        width: 100%;
      }
    }

    .kv_1v2 {
      position: absolute;
      left: 0;
      top: -6rem;
      width: 54%;
    }

    .btn-wrap {
      width: 40%;
      bottom: 12%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const SectionStyles = styled.div`
  position: relative;
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: var(--primary);
  margin-top: .8rem;
  margin-bottom: .8rem;

  .title {
    margin-bottom: 3rem;
    max-width: 65%;
  }

  .btn-wrap {
    display: block;
    width: 50%;
    margin: 6rem auto 0;
  }

  @media (min-width: ${breakPoint.min}) {
    padding-top: 10rem;
    padding-bottom: 10rem;
    background-color: var(--primary);
    margin-top: 1rem;
    margin-bottom: 1rem;
    .title {
      margin-bottom: 6rem;
      max-width: 44%;
    }
  }
  @media (max-width: ${breakPoint.max}) {
    .btn-wrap {
      display: block;
      margin: 3rem auto 0;
    }
  }
`;

const SectionStyles1 = styled(SectionStyles)`
  @media (min-width: ${breakPoint.min}) {
    .img_m2v2 {
      padding-right: 8%;
    }
  }
  @media (max-width: ${breakPoint.max}) {
    margin-top: 0;
  }
`;

const SectionStyles2 = styled(SectionStyles)`
  .img_3_1 {
    background-color: var(--tertiary);
    border-radius: 2.5rem;
    padding: 4rem 3rem;
  }

  @media (min-width: ${breakPoint.min}) {
    .img_3_1 {
      max-width: 150rem;
      width: 75%;
      margin-left: auto;
      margin-right: auto;
      padding: 8rem 6rem;
    }
  }
  @media (max-width: ${breakPoint.max}) {
    padding-right: 2rem;
    padding-left: 2rem;
  }
`;

const SectionStyles3 = styled(SectionStyles)`
  background-color: var(--tertiary);

  .mom-info {
    display: flex;
    justify-content: flex-start;

    > hgroup {
      flex: 1 1 100%;
      padding: 1rem 1rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      h2 {
        font-size: 1.5rem;
        border-top: 2px solid var(--primary);
        border-bottom: 2px solid var(--primary);
        padding: .4rem 1rem;
      }

      h3 {
        font-size: 1.3rem;
        margin-bottom: .8rem;
      }
    }
  }

  @media (min-width: ${breakPoint.min}) {
    .img_4_1 {
      max-width: 150rem;
      width: 75%;
      margin-left: auto;
      margin-right: auto;
    }

    .mom-info {
      max-width: 150rem;
      width: 75%;
      margin-left: auto;
      margin-right: auto;

      > hgroup {
        padding: 1 rm 2rem;

        h2 {
          font-size: 3rem;
          padding: .8rem 2rem;
        }

        h3 {
          font-size: 2rem;
        }
      }
    }

  }
  @media (max-width: ${breakPoint.max}) {
    padding-right: 2rem;
    padding-left: 2rem;
  }
`;

const SectionStyles4 = styled(SectionStyles)`
  position: relative;
  @media (min-width: ${breakPoint.min}) {
    .img_5_1 {
      max-width: 150rem;
      width: 75%;
      margin-left: auto;
      margin-right: auto;
    }

    .img_5_7 {
      display: none;
    }
  }
  @media (max-width: ${breakPoint.max}) {
    padding-top: 6rem;
    .img_5_1 {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
    }

    .img_5_7 {
      position: absolute;
      width: 15%;
      right: 10px;
      top: 20px;
    }
  }
`;

const SectionStyles5 = styled(SectionStyles)`

  @media (min-width: ${breakPoint.min}) {
    .img_5_1 {
      max-width: 150rem;
      width: 75%;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media (max-width: ${breakPoint.max}) {
    .img_5_1 {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const PostGroupStyles = styled(GridStyles)`
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  .post > .card {
    height: 100%;
  }

  @media (min-width: ${breakPoint.min}) {
    .post {
      &:nth-child(2), &:nth-child(4), &:nth-child(5), &:nth-child(7) {
        > .card {
          color: var(--secondary);
          background-color: white;
          border-width: 0;

          .img {
            margin-top: -.6rem;
          }

          hgroup {
            h2 {
              border-top-color: var(--priamry);
              border-bottom-color: var(--priamry);
            }
          }
        }

        .card-body {
          padding: 2rem 2.6rem 2.6rem;
        }
      }
    }
  }

  @media (max-width: ${breakPoint.max}) {
    width: 90%;
    .post {
      &:nth-child(3n - 3), &:nth-child(2) {
        > .card {
          color: var(--secondary);
          background-color: white;
          border-width: 0;

          .img {
            margin-top: -.6rem;
          }
        }

        hgroup {
          h2 {
            border-top-color: var(--priamry);
            border-bottom-color: var(--priamry);
          }
        }

        .card-body {
          padding: 1.5rem 2.1rem 2.1rem;
        }
      }
    }
  }
`;


const App = (props) => {
  const [postObj, setPostObj] = useState(null);

  const changePage = (i) => {
    scroller.scrollTo('section5')
    setPostObj((prev) => ({
      ...prev,
      currentPage: i
    }))
  }

  useEffect(() => {
    const x = window.matchMedia(`(max-width: ${breakPoint.max})`);
    if (posts.length > 0 && !postObj) {
      const _postObj = {
        currentPage: 0
      };
      if (x.matches) {
        _postObj.pageSize = 6;
      } else {
        _postObj.pageSize = 8;
      }
      _postObj.post = chunk(posts, _postObj.pageSize);

      setPostObj(_postObj);
    }
  }, [postObj, setPostObj]);

  return (
    <Layout className="bg-triangle">
      <KVStyles id="kv">
        <Img src={kv_banner_s} lgSrc={kv_banner} wrapProps={{className: 'kv_banner'}}/>
        <Img src={kv_1v2} wrapProps={{className: 'kv_1v2'}}/>
        <CusLink1 className="btn-wrap" to="section4">
          <Img src={img_m1_5} lgSrc={img_1_2}/>
        </CusLink1>
      </KVStyles>
      <SectionStyles1 id="section1">
        <Img src={img_mtitle1} lgSrc={img_title1} wrapProps={{className: 'title'}}/>
        <Img src={img_m2v2} lgSrc={img_02_1v2} wrapProps={{className: 'img_m2v2'}}/>
      </SectionStyles1>
      <SectionStyles2 id="section2">
        <Img src={img_mtitle2} lgSrc={img_title2} wrapProps={{className: 'title'}}/>
        <Img src={img_m3_2} lgSrc={img_3_1} wrapProps={{className: 'img_3_1'}}/>
      </SectionStyles2>
      <SectionStyles3 id="section3">
        <Img src={img_mtitle3} lgSrc={img_title3} wrapProps={{className: 'title'}}/>
        <Img src={img_m4_1} lgSrc={img_4_1} wrapProps={{className: 'img_4_1'}}/>
        <div className="mom-info">
          <hgroup>
            <h3>婦產科醫師</h3>
            <h2>張瑜芹</h2>
          </hgroup>
          <hgroup>
            <h3>皮膚科醫師</h3>
            <h2>吳明穎</h2>
          </hgroup>
          <hgroup>
            <h3>知名部落客</h3>
            <h2>牛牛肥滋滋</h2>
          </hgroup>
        </div>
        <CusLink className="btn-wrap" href="https://www.mombaby.com.tw/articles/9922966">
          <Img src={img_m4_2} lgSrc={img_4_2}/>
        </CusLink>
      </SectionStyles3>
      {
        !postObj ? (
          <SectionStyles4 id="section4">
            <Img src={img_mtitle4} lgSrc={img_title4} wrapProps={{className: 'title'}}/>
            <Img src={img_m5_1} lgSrc={img_5_1} wrapProps={{className: 'img_5_1'}}/>
            <Img src={img_m5_7} wrapProps={{className: 'img_5_7'}}/>
            <CusLink className="btn-wrap" href="https://forms.gle/b6ofCxGjzXRWbU2AA">
              <Img src={img_m5_8} lgSrc={img_5_8}/>
            </CusLink>
          </SectionStyles4>
        ) : (
          <SectionStyles5 id="section5">
            <Img src={img_mtitle5} lgSrc={img_title5} wrapProps={{className: 'title'}}/>
            <PostGroupStyles>
              {
                postObj.post[postObj.currentPage].map((item) => {
                  return (
                    <div key={uuid()} className="post">
                      <Card imgUrl={item.img}>
                        <hgroup>
                          <h3>媽咪</h3>
                          <h2>{item.name}</h2>
                        </hgroup>
                        <p>{item.desc}</p>
                      </Card>
                    </div>
                  )
                })
              }
            </PostGroupStyles>
            <Pagination pageSize={postObj.pageSize} totalCount={posts.length} currentPage={postObj.currentPage}
                        changePage={changePage}/>
          </SectionStyles5>
        )
      }

    </Layout>

  );
};

export default App;
